import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import {
  IniciativasSection,
  INICIATIVAS_TITLE,
} from 'volto-ministerio-publico-federal/components/View/CapaView/IniciativasSection';
import {
  iniciativasHasContent,
  type IniciativasData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfIniciativasBlockViewProps {
  data: IniciativasData;
  /** Presente só no editor: índice do card em `data.items`. */
  onEditItem?: (index: number) => void;
}

const EMPTY_TEXT =
  'Sem cards cadastrados. Adicione até três para a faixa aparecer na capa.';

/** Bloco "Iniciativas e Projetos (capa)". */
const MpfIniciativasBlockView = ({
  data,
  onEditItem,
}: MpfIniciativasBlockViewProps) => {
  // Sem itens o bloco ficaria invisível e o editor não conseguiria
  // selecioná-lo — daí o cartão tracejado com o texto gravado no bloco.
  if (!iniciativasHasContent(data)) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface dark:text-night-100">
          {data?.title || INICIATIVAS_TITLE}
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  /* `isEditMode={!!onEditItem}`, e não cravado em `true`: só o `Edit.tsx` passa
     `onEditItem`. Cravado, a página PUBLICADA herdava o comportamento de
     edição — slots vazios apareciam e os cards deixavam de ser links (ver os
     usos de `isEditMode` em `View/CapaView`). */
  return (
    <IniciativasSection
      data={data}
      isEditMode={!!onEditItem}
      onEditItem={onEditItem}
    />
  );
};

export default withBlockExtensions(MpfIniciativasBlockView);
